import BaseAPI from './base.api';
import {
  type MaterialCategoryRecord,
  type MaterialCategoryPayload,
} from 'views/DispatchImporters/CategoryManagement/types';

export default class MaterialCategoryAPI extends BaseAPI {
  getAll = async (): Promise<MaterialCategoryRecord[]> => {
    const response = await this.API.get('material-category', {
      params: { customerId: this.customerId },
    });
    return Array.isArray(response.data) ? response.data : [];
  };

  create = async (
    payload: MaterialCategoryPayload
  ): Promise<MaterialCategoryRecord> => {
    const response = await this.API.post('material-category', payload, {
      params: { customerId: this.customerId },
    });
    return response.data;
  };

  update = async (
    enumValue: string,
    payload: Pick<MaterialCategoryPayload, 'category'>
  ): Promise<MaterialCategoryRecord> => {
    const response = await this.API.put(
      `material-category/${encodeURIComponent(enumValue)}`,
      payload,
      { params: { customerId: this.customerId } }
    );
    return response.data;
  };

  remove = async (enumValue: string): Promise<void> => {
    await this.API.delete(
      `material-category/${encodeURIComponent(enumValue)}`,
      { params: { customerId: this.customerId } }
    );
  };
}
